var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.3c50dd523f059e52ec330f9cfce630e3.svg#m';
                    var viewUrl = 'sprites.3c50dd523f059e52ec330f9cfce630e3.svg#view-m';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 31 21',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };